import React from 'react';
import { Form, Input } from 'antd';




export default function UserFilter(props) {    
    return (
        <Form
            form={props.form}
            labelAlign={"left"}
            layout={"vertical"}
        >
            <Form.Item
                name={"Email"}
                label={"Email"}
                rules={[
                    {
                        type: 'email',
                        message: 'Введен неверный Email!',
                    },
                    { required: true, message: 'Укажите Email!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"Lastname"}
                label={"Фамилия"}
                rules={[{ required: true, message: 'Укажите фамилию!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"Firstname"}
                label={"Имя"}
                rules={[{ required: true, message: 'Укажите имя!' }]}
            >
                <Input />
            </Form.Item>
        </Form>
    );
}
